export default "__VITE_ASSET__Cn2SMP7D__"